import React from "react"
import parse from "html-react-parser"

const ContentSummary = ({ keyTakeaways }) => {
    //console.log(keyTakeaways)
    const { summary, keyTakeaways: takeaways } = keyTakeaways
    
    return (summary && takeaways)
        ? (
            <section>
            <h2>Summary</h2>
            {parse(summary)}
            <h3>Key Takeaways</h3>
            {parse(takeaways)}
            </section>
          )
        : (summary)
            ? (
                <section>
                <h2>Summary</h2>
                {parse(summary)}
                </section>
            
              )
            : null
}
export default ContentSummary